import { h, Fragment } from 'preact'
import { useState } from 'preact/hooks'
import Dropzone from 'react-dropzone'
import ContentEditable from 'react-contenteditable'

const CLOUDINARY_UPLOAD_URL = 'https://api.cloudinary.com/v1_1/triple-e-rv/image/upload'
const CLOUDINARY_UPLOAD_PRESET = 'qd1bamq4'

export const Result = ({ quote, quoteName, id }) => {
  const [text, setText] = useState(quote)
  const [name, setName] = useState(quoteName)
  const [profile, setProfile] = useState(
    'https://leisurevans.com/wp-content/themes/ltv-wp/img/owners/dashboard/default-avatar.jpg'
  )
  const [imageUrl, setImageUrl] = useState(
    'https://leisurevans.com/wp-content/themes/ltv-wp/img/top-hero/2019-trio.jpg'
  )

  const onDrop = (acceptedFiles, rejectedFiles, event) => {
    handleImageUpload(acceptedFiles[0], event.target.dataset.target)
  }

  const handleImageUpload = async (file, target) => {
    const formData = new FormData()
    formData.append('upload_preset', CLOUDINARY_UPLOAD_PRESET)
    formData.append('file', file)
    try {
      const upload = await fetch(CLOUDINARY_UPLOAD_URL, {
        method: 'POST',
        body: formData,
      })
      const json = await upload.json()
      console.log(json)
      if (target === 'bg-image') {
        setImageUrl(json.secure_url)
      } else if (target === 'profile-image') {
        setProfile(json.secure_url)
      }
    } catch (err) {
      console.error(err)
    }
  }

  return (
    <Fragment>
      <div class='result' id={id}>
        <div>
          <Dropzone onDrop={onDrop} noDrag={true}>
            {({ getRootProps, getInputProps }) => (
              <span {...getRootProps({ className: 'edit-image' })} data-html2canvas-ignore>
                <input {...getInputProps()} name='bg-image' data-target='bg-image' />
                <span role='img' aria-label='edit'>
                  ✏️
                </span>{' '}
                EDIT
              </span>
            )}
          </Dropzone>
          <span class='result-quote'>“</span>
          <ContentEditable
            tagName='span'
            html={text} // innerHTML of the editable div
            className='result-body'
            onChange={event => setText(event.target.value)} // handle innerHTML change
          />
          <Dropzone onDrop={onDrop} noDrag={true}>
            {({ getRootProps, getInputProps }) => (
              <span {...getRootProps({ className: 'result-profile' })}>
                <input {...getInputProps()} name='profile-image' data-target='profile-image' />
              </span>
            )}
          </Dropzone>
          <ContentEditable
            tagName='span'
            html={name} // innerHTML of the editable div
            className='result-name'
            onChange={event => setName(event.target.value)} // handle innerHTML change
          />
        </div>
      </div>
      <style jsx>{`
        .result {
          position: relative;
          padding: 10px;
          height: 500px;
          width: 500px;
          background: white;
          background-image: url('${imageUrl}');
          background-size: cover;
          background-position: center center;
          font-family: 'theinhardt', sans-serif;
          margin: 10px auto;
        }

        .result::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background-color: #33a889;
          opacity: 0.6;
        }

        .result-quote {
          position: absolute;
          width: 4rem;
          left: 50%;
          top: 1rem;
          margin-left: -1.5rem;
          display: block;
          font-family: 'farnham display', serif;
          font-weight: 600;
          font-size: 7rem;
          color: #fff;
          opacity: 0.25;
        }

        .result-body {
          position: relative;
          display: block;
          margin: 6rem auto 0 auto;
          width: 90%;
          text-align: center;
          font-family: 'farnham display', serif;
          font-weight: 500;
          font-size: 2.5rem;
          line-height: 1.2;
          color: #fff;
          white-space: normal;
        }

        .result-profile {
          position: absolute;
          left: 0;
          right: 0;
          bottom: 6rem;
          margin: 0 auto;
          width: 75px;
          height: 75px;
          background-image: url('${profile}');
          background-size: cover;
          border-radius: 50%;
        }

        .result-profile:hover::after {
          display: block;
          cursor: pointer;
        }

        .result-profile::after {
          content: '✏️ EDIT';
          color: #fff;
          text-align: center;
          line-height: 75px;
          font-weight: bold;
          letter-spacing: 1px;
          position: absolute;
          display: none;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background-color: #33a889;
          border-radius: 50%;
        }

        .result-name {
          position: absolute;
          width: 90%;
          margin: 0 auto;
          bottom: 3rem;
          left: 0;
          right: 0;
          text-align: center;
          text-transform: uppercase;
          letter-spacing: 2px;
          font-size: 1.5rem;
          font-weight: 700;
          color: #fff;
          white-space: normal;
        }

        .edit-image {
          position: absolute;
          top: 1rem;
          right: 1rem;
          padding: 0.5rem;
          background: white;
          border-radius: 0.25rem;
          font-weight: bold;
          letter-spacing: 1px;
          border: 1px solid #fff;
        }

        .edit-image:hover {
          cursor: pointer;
          border: 1px solid #555;;
        }
      `}</style>
    </Fragment>
  )
}
